import React from 'react';
import Slider from './Slider.jsx';
import {Link} from "react-router-dom";

const Header = () =>
	<header>
		<div className='logo'>`housing`</div>
		<div className='we'>
			Ми експортуємо, проектуємо та виготовляєм садовi глечики
			як зовнiшнього, так i внутрiшнього интер'єра з 2017 року.
			Довiра наших клiєнтiв є головним прiорiтетом для `Housing`.
			Тримати чесне iм'я та вiдданiсть свойому ремеслу зобов'язує
			нас зусереджуватись на кажнiй деталi, на кажнiй линиi.
		</div>
		<div className='founder'>
			<span>Олександр Оградка</span><br/>
			засновник `Housing`
		</div>
	</header>

export default Header;